import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { BLOG_POSTS } from "@/data/content";
import { Input } from "@/components/ui/input";
import { Search as SearchIcon, ArrowUpRight } from "lucide-react";

export default function Blog() {
    const [q, setQ] = useState("");
    const filtered = useMemo(() => {
        const s = q.trim().toLowerCase();
        if (!s) return BLOG_POSTS;
        return BLOG_POSTS.filter((p) => p.title.toLowerCase().includes(s) || p.excerpt.toLowerCase().includes(s) || p.category.toLowerCase().includes(s));
    }, [q]);

    return (
        <>
            <PageHeader
                eyebrow="Blog"
                title="Long-form playbooks, no fluff."
                subtitle="Buying guides, honest reviews and deep-dives on what's actually worth your money."
            />
            <section className="container-editorial pb-8">
                <div className="relative max-w-md">
                    <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
                    <Input value={q} onChange={(e) => setQ(e.target.value)} data-testid="blog-search" className="pl-9 h-11" placeholder="Search articles…" />
                </div>
            </section>
            <section className="container-editorial pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filtered.map((p) => (
                    <Link to={`/blog/${p.slug}`} key={p.slug} data-testid={`blog-card-${p.slug}`} className="group">
                        <div className="aspect-[4/3] overflow-hidden rounded-lg border border-stone-200">
                            <img src={p.cover} alt={p.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition duration-500" />
                        </div>
                        <div className="mt-4">
                            <p className="label-eyebrow text-accent">{p.category} · {p.readingTime} min · {p.date}</p>
                            <h2 className="font-serif text-2xl mt-2 leading-tight group-hover:text-primary">{p.title}</h2>
                            <p className="text-stone-600 mt-2 text-sm line-clamp-3">{p.excerpt}</p>
                            <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary">Read <ArrowUpRight className="h-4 w-4" /></span>
                        </div>
                    </Link>
                ))}
            </section>
        </>
    );
}
